import React from 'react'
import { motion as m } from 'framer-motion'
import store from '../store/store'

export default function Burger() {
    const isMenuOpen = store((state) => state.isMenuOpen)
    const setIsMenuOpen = store((state) => state.setIsMenuOpen)
    
    // handle opening/closing menu
    const handleMenu = () => {
      setIsMenuOpen(!isMenuOpen)
    }

    return (
        <m.div 
            id='burger_menu' 
            onClick={handleMenu} 
            whileTap={{ scale: 0.9 }}
            whileHover={{ scale: 1.1 }}
        >
            <div className='burger_stroke' id={isMenuOpen?'burger_stroke_open' : 'burger_stroke_close'} ></div>
        </m.div>
  )
}
